// extracted by mini-css-extract-plugin
export default {"container":"loader_container__Oab2n","content":"loader_content__GLjRs","wrap":"loader_wrap__f80ii"};